







































































































































































































































































































































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Headquarter } from '@/data/models/headquarter.model';
import { cloneDeep } from 'lodash';
import { currencyToNumber, numberMask } from '@/data/utils/helper';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class HeadquarterGeneralData extends Vue {
	@Prop() headquarter!: Headquarter;
	@Prop() editable!: boolean;

	@Inject('CrudService') headquarterCrudService!: CrudService<Headquarter>;

	newHeadquarter!: Headquarter;

	numberMask: any = numberMask();

	currencies: any = {};

	constructor() {
		super();
		this.newHeadquarter = new Headquarter();
	}

	@Watch('headquarter', { immediate: true })
	onHeadquarterChange() {
		this.newHeadquarter = cloneDeep(this.headquarter);
	}

	onCurrencyChange(event: any, field: string) {
		this.currencies[field] = currencyToNumber(event.target._vCleave.getFormattedValue());
	}

	submit() {
		Object.keys(this.currencies).forEach(k => {
			this.$set(this.newHeadquarter, k, this.currencies[k]);
		});
		this.headquarterCrudService
			.createEntity(Headquarter, 'headquarter', this.newHeadquarter)
			.then((headquarter: Headquarter) => {
				this.newHeadquarter = headquarter;
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				this.$emit('update:headquarter', headquarter);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

}
